const map = {
	"./de/cinqueterre.json": [
		8594,
		[
			699
		]
	],
	"./de/legal.json": [
		4564,
		[
			114
		]
	],
	"./de/translation.json": [
		7778,
		[
			305
		]
	],
	"./en/cinqueterre.json": [
		2282,
		[
			496
		]
	],
	"./en/legal.json": [
		5596,
		[
			519
		]
	],
	"./en/translation.json": [
		4362,
		[]
	],
	"./es/cinqueterre.json": [
		9565,
		[
			317
		]
	],
	"./es/legal.json": [
		8675,
		[
			508
		]
	],
	"./es/translation.json": [
		6089,
		[
			91
		]
	],
	"./fr/cinqueterre.json": [
		1541,
		[
			282
		]
	],
	"./fr/legal.json": [
		6779,
		[
			150
		]
	],
	"./fr/translation.json": [
		9633,
		[
			543
		]
	],
	"./it/cinqueterre.json": [
		9192,
		[
			532
		]
	],
	"./it/legal.json": [
		182,
		[
			341
		]
	],
	"./it/translation.json": [
		1708,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8564;
module.exports = webpackAsyncContext;